import { Grid, makeStyles, TextField } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import welcomeImage from "../../img/Welcome_background.png"
import { Box, Button } from "@mui/material";
import AnniversariesService from "../../services/AnniversariesService";
import CanvasWrapper from "./CanvasWrapper";

export default function WelcomeTemplateBuilder() {
    const classes = useStyles();
    const [imgWidth, setImgWidth] = useState(0)
    const [fullNames, setFullNames] = useState<string[]>(['','','',''])
    const imageRef = useRef<any>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);

    const fontFamily = "Nunito"
    const shadowColor = "#0000005E"

    useEffect(() => {
      loadCanvasSize();
      renderNames();
    },[imageRef.current])

    useEffect(() => {
      clearCanvas();
      renderNames();
    },[fullNames])

    const getCanvas2DContext = () => canvasRef.current!.getContext('2d');

    const loadCanvasSize = () => {
      const canvas = getCanvas2DContext()!.canvas;
      canvas.width = imageRef.current.width;
      canvas.height = imageRef.current.height;
    }

    const canvasCommonProperties = () => {
      const canvas = getCanvas2DContext();
      canvas!.fillStyle = "white";
      canvas!.shadowColor = shadowColor;
      canvas!.shadowOffsetX = 3;
      canvas!.shadowOffsetY = 3;
      canvas!.shadowBlur = 5;
    }

    const renderNames = () => {
      const canvas = getCanvas2DContext();
      const fontSize = 30;
      canvasCommonProperties()
      canvas!.font = `700 italic ${fontSize}px ${fontFamily}`;
      canvas!.textAlign = "center";
      const namesToRender = fullNames.filter(name => name.trim().length > 0)
  
      if(namesToRender.length == 1){
        canvas!.fillText(`@${namesToRender[0]}`, (canvasRef.current!.width / 2.6) , (canvasRef.current!.height / 1.14)) 
      }else if(namesToRender.length == 2){
        canvas!.fillText(`@${namesToRender[0]}`, (canvasRef.current!.width / 2.6) / 2  , (canvasRef.current!.height / 1.14)) 
        canvas!.fillText(`@${namesToRender[1]}`, (canvasRef.current!.width / 2.6) * 1.5 , (canvasRef.current!.height / 1.14)) 
      }else{
        canvas!.fillText(`@${namesToRender[0]}`, (canvasRef.current!.width / 2.6) / 2  , (canvasRef.current!.height / 1.18)) 
        namesToRender[1] && canvas!.fillText(`@${namesToRender[1]}`, (canvasRef.current!.width / 2.6) * 1.5 , (canvasRef.current!.height / 1.18)) 
        namesToRender[2] && canvas!.fillText(`@${namesToRender[2]}`, (canvasRef.current!.width / 2.6) / 2  , (canvasRef.current!.height / 1.08)) 
      }
    
      if(namesToRender.length == 4){
         canvas!.fillText(`@${namesToRender[3]}`, (canvasRef.current!.width / 2.6) * 1.5 , (canvasRef.current!.height / 1.08)) 
      }

    }

    const clearCanvas = () => {
      const canvas = getCanvas2DContext();
      canvas!.clearRect(0, 0, canvasRef.current!.width, canvasRef.current!.height)
    }

    const prepareSave = () => {
      const img = new Image();
      img.src = welcomeImage;
      img.addEventListener("load", () => {
        canvasRef.current!.height = img.height;
        canvasRef.current!.width = img.width;
        getCanvas2DContext()!.drawImage(img, 0, 0);
        renderNames();
        saveCanvasAsImage();
      })
    }

    
    const prepareImageToBackend = () => {
      const img = new Image();
      img.src = welcomeImage;
      img.addEventListener("load", () => {
        canvasRef.current!.height = img.height;
        canvasRef.current!.width = img.width;
        getCanvas2DContext()!.drawImage(img, 0, 0);
        renderNames();
        sendImageToBackend();
      })
    }

    const handleOnChangeName = (index:number, value:string) => {
        const updateNames = fullNames;
        updateNames[index] = value
        setFullNames([...updateNames])
    }

    const sendImageToBackend = () => {
      const canvas = canvasRef.current;
      const dataUrl =  canvas!.toDataURL('image/png'); 
      const formData = new FormData();
  
      fetch(dataUrl).then(response => response.blob()).then(blob => {
        formData.append("image", blob, "image.png");
        AnniversariesService.uploadTemplateImageToBackend(formData, fullNames.filter(name => name.trim().length > 0));
      })
  }

    const saveCanvasAsImage = () => {
      const canvas = canvasRef.current;
      const link = document.createElement('a');

      link.download = `welcome-image-${Date.now()}.png`;
      link.href = canvas!.toDataURL('image/png'); 
      link.click()

    }

  return <>
    <Grid container style={{ 
            display: 'flex', 
            alignItems: 'flex-start',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: '1rem',
            boxSizing: 'inherit',
            boxShadow: 'none',    
          }}>
      <Grid item xs={6}>
        <TextField
          type="text"
          className={classes.textField}
          label="Name one"
          value={fullNames[0]}
          onChange={(e:any) => {handleOnChangeName(0, e.target.value)}}
          autoComplete="off"
          size="small"
          />
      </Grid>
      <Grid item xs={6}>
        <TextField
          type="text"
          className={classes.textField}
          label="Name two"
          value={fullNames[1]}
          onChange={(e:any) => {handleOnChangeName(1, e.target.value)}}
          autoComplete="off"
          size="small"
          />
      </Grid>
      <Grid item xs={6}>
        <TextField
          type="text"
          className={classes.textField}
          label="Name three"
          value={fullNames[2]}
          onChange={(e:any) => {handleOnChangeName(2, e.target.value)}}
          autoComplete="off"
          size="small"
          />
      </Grid>
      <Grid item xs={6}>
        <TextField
          type="text"
          className={classes.textField}
          label="Name four"
          value={fullNames[3]}
          onChange={(e:any) => {handleOnChangeName(3, e.target.value)}}
          autoComplete="off"
          size="small"
          />
      </Grid>
    </Grid>

    <CanvasWrapper width={imgWidth} setWidth={setImgWidth} image={welcomeImage}>
      <Grid container>
        <Grid className={classes.container} xs={12}>
          <img ref={imageRef} className={classes.backgroundImage} src={welcomeImage} alt=""/>
          <canvas className={classes.canvas} ref={canvasRef}></canvas>
        </Grid>
      </Grid>
    </CanvasWrapper>

    <Button onClick={prepareSave}>Download</Button>

    <Button onClick={prepareImageToBackend}>Send to slack</Button>
  </>
}

const useStyles = makeStyles(() => ({
  container: {
    position:"relative",
  },
  backgroundImage:{
    position:"absolute"
  },
  textField: {
  },
  canvas: {
    zIndex:100,
    position:"relative",
  }
}),
{ index: 1 },
);
